import { fetchFromUrlPOSTAsync } from '../fetch/';

export const actions = {

  getFirstQuizResults: async () => {
    const result = await fetchFromUrlPOSTAsync('/user_first_quiz/get_results', []);
    return result.success ? result.data : [];
  },
};
